import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Server from '../../../functions/server';
import Radio from '@material-ui/core/Radio';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
  };

  componentDidMount() {
    this.getDetails();
  }

  componentDidUpdate(props) {
    if (props.data.length != this.props.data.length) {
      this.getDetails();
    }
  }

  getDetails() {
    let data = this.props.data;
    if (data.length >= 1) {
      let details, hypothicated;
      data.map((x) => { details = x.details; hypothicated = x.hypothicated;
      })
      this.setState({ hypothicated, details })
    }
  }

  handleClickOpen = () => { this.setState({ open: true }); };

  handleClose = () => { this.setState({ open: false }); };

  handleMaxWidthChange = event => { this.setState({ maxWidth: event.target.value }); };

  handleFullWidthChange = event => { this.setState({ fullWidth: event.target.checked }); };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  submit = () => {
    let contexte= this;
    let machineNo = this.state.machineNo;
    let engineNo = this.state.engineNo;
    let orderId = this.props.id;
    let hypothicated = this.state.hypothicated;
    let details = this.state.details;
    let printingtype = this.state.selectedValue;
    if (machineNo == null || machineNo == undefined || machineNo == '') {
      alert('Enter Machine Number!!!');
      return;
    }
    if (engineNo == null || engineNo == undefined || engineNo == '') {
      alert('Enter Engine Number!!!');
      return;
    }
    if (hypothicated == null || hypothicated == undefined || hypothicated == '') {
      alert('Enter hypothicated!!!');
      return;
    }
    if (details == null || details == undefined || details == '') {
      alert('Enter details!!!');
      return;
    }
    if (printingtype == null || printingtype == undefined || printingtype == '') {
      alert('Enter printingtype!!!');
      return;
    }
    this.setState({ open: false, machineNo: '', engineNo: '' })
    let open = Server() + "pdf/mechinepurchaseinvoice.php?orderId="+orderId+"&engineNo="+engineNo+
                           "&machineNo="+machineNo+"&type="+this.state.selectedValue+"&hypothicated="+
                           hypothicated+"&details="+details;
    window.open(open);
  }

  handleChangeselect = event => {
    this.setState({ selectedValue: event.target.value });
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div style={{ cursor: 'pointer' }} onClick={this.handleClickOpen}>Generate</div>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth} open={this.state.open}
          onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Generate Invoice</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Machine Number<br/>
                <Input value={this.state.machineNo} onChange={this.handleChange('machineNo')} fluid focus />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={5}>
                Engine Number<br/>
                <Input value={this.state.engineNo} onChange={this.handleChange('engineNo')} fluid focus />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={6}>
                <Radio checked={this.state.selectedValue === 'paper'}
                  label='Cash'
                  onChange={this.handleChangeselect}  value="paper"
                  name="radio-button-demo" aria-label="Plain Paper" />Paper
                <Radio checked={this.state.selectedValue === 'pad'}
                  onChange={this.handleChangeselect}  value="pad"
                  name="radio-button-demo" aria-label="Letter Pad" />Pad
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <Form>
                  Hypothicated<br/>
                  <TextArea placeholder='HYPOTHICATED' value={this.state.hypothicated}
                    onChange={this.handleChange('hypothicated')} fluid focus />
                    <br/><br/>
                  Details<br/>
                  <TextArea placeholder='Details' value={this.state.details}
                    onChange={this.handleChange('details')} fluid focus />
                </Form>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={7}>
                <Button primary onClick={this.submit}>Submit</Button>
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.handleClose} color="primary">
              Close
            </Buttons>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
